import { createAppVersionCheckStore } from '@thyme/libs/src/version/checkNewVersion'
import { loadVersionMetadata } from '@thyme/libs/src/version/version'

// Get the canary status at app startup to determine whether this deployment is from canary or primary
const { canaryStatus } = await loadVersionMetadata()

export const useAppVersionChecker = createAppVersionCheckStore(
  APP_VERSION,
  canaryStatus
)
